import clientReceivepaymentFullcont from "./clientReceivepayment-fullcont.html";

const dialog = require('../../../../../components/dialog/dialog')
const fullcontEntity = require('../../../../../components/fullcont/fullcont-entity')
const fullcontHandler = require('../../../../../components/fullcont/fullcont-handler')
const clientReceivepaymentDt = require('./clientReceivepayment-dt')
const clientReceivepaymentMenu = require('./clientReceivepayment-menu')
const handler = require('./clientReceivepayment-fullcont-handler')
const { formCopy } = require('./clientReceivepayment-fullcont-form')
const { form } = require('./clientReceivepayment-fullcont-form')
const { clientReceivepaymentMT } = require('./clientReceivepayment-fullcont-multitable')
const timeDate = require('../../../../../js-handler/time-date')

/****************ELEMENTS*****************/
var htmlFc = {}
var HTMLwasSelected = false
let dest = null;

function HTMLselect(detail) {

      fullcontHandler.HTMLselect(

            'clientReceivepayment', //database table name****
            // 'clientActivity', //dest entity on js
            dest, //dest entity on js
            'clientReceivepayment-fullcont',
            clientReceivepaymentFullcont, form, formCopy, clientReceivepaymentMT,
            editDialog, deleteDialog, dtCall, htmlFc)

      HTMLwasSelected = true

      // htmlFc.hasFiles = true
      // fullcontHandler.rightsControl(htmlFc)
}/**/


export function start(detail) {  //console.log('clientReceivepayment-dt 5>', detail)

      if (detail.act === "selectOne") {
            dest = "clientPayments";
      } else {
            // se resetea el "HTMLselect"
            dest = "clientReceivepayment";
            HTMLwasSelected = false
      }

      if (!HTMLwasSelected) { HTMLselect(detail) }

      obj[detail.act].start(detail)
}/**/


const obj = {

      addOne: {
            start: (detail) => {
                  if (handler.verifyMultitable(detail, htmlFc)) {
                        addOne(detail, htmlFc)
                  }
            }
      },
      cancelEdit: { start: (detail) => { fullcontEntity.cancelEdit(detail, htmlFc) } },
      deleteEntity: { start: (detail) => { deleteEntity(detail, htmlFc) } },
      deleteFromDialog: { start: (detail) => { deleteFromDialog(detail, htmlFc) } },
      discard: { start: (detail) => { fullcontHandler.discard(detail, htmlFc) } },
      fullcontOptions: { start: (detail) => { clientReceivepaymentMenu.start(detail, 'htmlDt', htmlFc) } },
      hide: { start: (detail) => { fullcontEntity.hide(detail, htmlFc) } },
      prepareAdd: { start: (detail) => { fullcontEntity.prepareAdd(detail, htmlFc, setDefaultValue) } },
      prepareEdit: { start: (detail) => { fullcontHandler.prepareEdit(detail, htmlFc) } },
      saveFromDialog: {
            start: (detail) => {
                  if (handler.verifyMultitable(detail, htmlFc)) {
                        fullcontEntity.saveFromDialog(detail, htmlFc, afterprocess)
                  }
            }
      },
      selectOne: { start: (detail) => { fullcontEntity.selectOne(detail, htmlFc, afterprocess) } },
      selectOneNoCheck: { start: (detail) => { fullcontEntity.selectOneNoCheck(detail, htmlFc, afterprocess) } },
      update: {
            start: (detail) => {
                  if (handler.verifyMultitable(detail, htmlFc)) {
                        fullcontEntity.update(detail, htmlFc, afterprocess)
                  }
            }
      },
      getAllInvoice: { start: (detail) => { handler.getAllInvoice(detail, htmlFc) } },
      validated_press: { start: (detail) => { handler.validated_press(detail, htmlFc) } },
      reportPdf: { start: (detail) => { handler.reportPdf(detail, htmlFc) } },
      verifyvalue: { start: (detail) => { handler.verifyvalue(detail, htmlFc) } },
      verifyamount: { start: (detail) => { handler.verifyamount(detail, htmlFc) } },
      addAmount: { start: (detail) => { handler.addAmount(detail, htmlFc) } },
      beforeAutocomplete: { start: (detail) => { handler.beforeAutocomplete(detail, htmlFc) } },
      otherFieldCredit: { start: (detail) => { handler.otherFieldCredit(detail, htmlFc) } },

      pdfMenuFullcont: { start: (detail) => { pdfMenuFullcont(detail, htmlFc) } },

}/**/

export function pdfMenuFullcont(detail, htmlFc) {
      const fullcont = htmlFc.fullcontHTML ?? null;
      const dbid = fullcont.getAttribute("data-dbid") ?? detail.dbid;
      printReport(dbid, detail.entity, detail.reportName);
}

function printReport(dbid, entity, reportName) {
      const formData = new FormData();
      formData.append('id', dbid);
      formData.append('type', 'print');
      formData.append('entity', entity);
      formData.append('reportName', reportName);

      const isPdf = true;

      const controller = new AbortController();
      const timeout = setTimeout(() => { controller.abort() }, 30000);

      let options = {
            method: 'POST',
            body: formData,
            signal: controller.signal,
            credentials: 'same-origin'
      };

      fetch(`./server/php/report/report-pdf.php`, options)
            .then((response) => {
                  clearTimeout(timeout);
                  if (!response.ok) throw new Error("report-pdf");
                  // 1. Cambiamos .text() por .blob() para manejar el binario del PDF correctamente

                  return response.blob();
            })
            .then((blob) => {
                  if (isPdf) {
                        // --- LÓGICA PARA PDF ---
                        const pdfBlob = new Blob([blob], { type: "application/pdf" });
                        const fileUrl = URL.createObjectURL(pdfBlob);
                        const newTab = window.open(fileUrl, "_blank");

                        if (newTab) {
                              newTab.addEventListener('load', () => {
                                    URL.revokeObjectURL(fileUrl);
                              }, { once: true });
                        }
                  } else {
                        // --- LÓGICA PARA CSV ---
                        // Se define el MIME type para CSV
                        const csvBlob = new Blob([blob], { type: "text/csv;charset=utf-8;" });
                        const fileUrl = URL.createObjectURL(csvBlob);

                        // Creamos un enlace temporal en el DOM
                        const tempLink = document.createElement("a");
                        tempLink.href = fileUrl;

                        // Asignamos un nombre de archivo por defecto (puedes personalizarlo)
                        tempLink.setAttribute("download", `report_${new Date().getTime()}.csv`);
                        tempLink.style.display = "none";

                        document.body.appendChild(tempLink);
                        tempLink.click(); // Disparamos la descarga

                        // Limpiamos el DOM y liberamos la memoria
                        document.body.removeChild(tempLink);
                        URL.revokeObjectURL(fileUrl);
                  }
            })

            .catch(error => {
                  throw error;
            });
}

//function to send
function editDialog() {
      dialog.start({ act: "show", id: "saveChanges", entity: 'clientReceivepayment' })
}

function deleteDialog(detail) {
      dialog.start({ act: "show", dest: 'clientReceivepayment', id: "deleteElem", entity: 'clientReceivepayment', dbid: detail.dbid })
}

function dtCall(act, result) {
      clientReceivepaymentDt.start({ act: act, row: result })
}

function addOne(detail, htmlFc) {

      fullcontEntity.addOne(detail, htmlFc)
      setTimeout(() => {
            // investorDt.start({"dest":"investor", "elem":"dt", "act":"select", "entity":"investor"})  
      }, 100)

}


function deleteFromDialog(detail, htmlFc) {

      fullcontEntity.deleteFromDialog(detail, htmlFc)
      setTimeout(() => {
            clientReceivepaymentDt.start({ "dest": "clientReceivepayment", "elem": "dt", "act": "select", "entity": "clientReceivepayment" })
      }, 900)

}

//Function to set default values to fullcont fields when creating a record is pressed
function setDefaultValue(htmlFc) {

      let sale_date = htmlFc.fullcontHTML.querySelector('#clientReceivepayment_form_date input');
      sale_date.value = timeDate.convertDateToInput();


      htmlFc.formCopy.forEach(element => {

            if (element.name == "date") {
                  element.value = sale_date.value;
            }
      });
}


function afterprocess(data, result) {
      handler.blockSaleHasCredit(data, htmlFc)
}


async function deleteEntity(detail, htmlFc) {
      if (await handler.verifyReceiveHasSaleWithCredit(detail.dbid.join(','), htmlFc)) {
            fullcontEntity.deleteEntity(detail, htmlFc)
      }

}
